import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toWords } from "number-to-words";

const MiscellaneousFeeReceipt = (receiptData) => {
  if (!receiptData || !Array.isArray(receiptData) || receiptData.length === 0) {
    alert("No data available to export.");
    return;
  }

  const capitalizeWords = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  doc.setFontSize(8);

  const renderReceipt = (data, startX, startY, copyTitle) => {
    const tableData = [];
    const amount = parseFloat(data?.amount || 0);
    const feeType = data?.type || "Miscellaneous Fee";
    tableData.push(["1.", feeType, amount.toFixed(2)]);
    tableData.push(["", "Total Amount", amount.toFixed(2)]);

    const pageWidth = doc.internal.pageSize.getWidth();
    const receiptWidth = pageWidth / 2;
    const centerX = startX + receiptWidth / 2;
    const logoWidth = 15;
    const logoHeight = 15;
    const logoX = centerX - logoWidth / 2;
    const logoY = startY - 5;
    const schoolLogo = "/assets/images/icon.png";

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    doc.text(copyTitle, startX + 10, 5);
    doc.addImage(schoolLogo, "PNG", logoX + 2, logoY, logoWidth, logoHeight);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Acharyakulam", centerX + 2, startY + 15, { align: "center" });
    doc.setFontSize(7);
    doc.text(
      `SESSION ${data?.session || "2025-26"}`,
      centerX + 2,
      startY + 18,
      {
        align: "center",
      }
    );

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(
      "Near Namkum Police Station, Tata Road, Namkum, Ranchi - 834010",
      centerX + 2,
      startY + 22,
      { align: "center" }
    );
    doc.text("www.acharyakulamranchi.com", centerX + 2, startY + 25, {
      align: "center",
    });
    doc.text(
      "6287842461, 6287842463, 06512950555",
      centerX + 2,
      startY + 28.5,
      {
        align: "center",
      }
    );

    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("MISCELLANEOUS FEE RECEIPT", centerX + 2, startY + 33, {
      align: "center",
    });

    const student = data?.student || {};
    const fatherName =
      student?.parentDetails?.find((p) => p.relation === "Father")?.name ||
      "N/A";

    const studentInfo = `Student's Name : ${
      student?.name || data?.studentName || "N/A"
    }
Father's Name : ${fatherName}
Phone No : ${student?.parentDetails?.[0]?.phone || "N/A"}
Class : ${student?.currentClass || "N/A"}`;

    const receiptInfo = `Receipt No : ${data?.receipt_no || "N/A"}
Date : ${new Date(data?.createdAt).toLocaleDateString("en-GB")}
Admission No : ${data?.formNo || "N/A"}`;

    autoTable(doc, {
      startY: startY + 38,
      body: [
        [
          {
            content: studentInfo,
            styles: {
              fontSize: 7,
              cellPadding: 2,
              halign: "left",
              valign: "top",
              textColor: 0,
            },
          },
          {
            content: receiptInfo,
            styles: {
              fontSize: 7,
              cellPadding: 2,
              halign: "right",
              valign: "top",
              textColor: 0,
            },
          },
        ],
      ],
      theme: "grid",
      styles: { fontSize: 5, cellPadding: 1, lineColor: 0, lineWidth: 0.1 },
      columnStyles: { 0: { cellWidth: 45 }, 1: { cellWidth: 45 } },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 2,
      head: [["#", "Fee Head (Description)", "Amount"]],
      body: tableData,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: 0,
        lineWidth: 0.1,
        textColor: 0,
      },
      headStyles: {
        fontSize: 7,
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.1,
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 55 },
        2: { cellWidth: 25 },
      },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    const amountInWords = `${capitalizeWords(toWords(amount))} Only`;

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 2,
      head: [["Total Amount (In Words)"]],
      body: [[amountInWords]],
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: 0,
        lineWidth: 0.1,
        textColor: 0,
      },
      headStyles: {
        fontSize: 7,
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.1,
      },
      columnStyles: { 0: { cellWidth: 90 } },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    const paymentModeData = [];
    if (data?.mode && data.mode !== "Cash") {
      paymentModeData.push(["Mode Of Payment", data.mode]);
      if (data?.paymentId) paymentModeData.push(["Payment ID", data.paymentId]);
      if (data?.bank) paymentModeData.push(["Bank", data.bank]);
    } else {
      paymentModeData.push(["Mode Of Payment", "Cash"]);
    }

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 2,
      head: [["Mode Of Payment", "Amount"]],
      body: paymentModeData.map(([label, val]) => [label, val]),
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: 0,
        lineWidth: 0.1,
        textColor: 0,
      },
      headStyles: {
        fontSize: 7,
        fillColor: [255, 255, 255],
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.1,
      },
      columnStyles: { 0: { cellWidth: 55 }, 1: { cellWidth: 35 } },
      tableWidth: receiptWidth - 20,
      margin: { left: startX + 10 },
    });

    doc.setFontSize(7);
    doc.text(
      "Authorized Signature",
      startX + 70,
      doc.lastAutoTable.finalY + 15
    );
  };

  let startY = 10;
  const receiptHeight = 140;

  receiptData.forEach((data) => {
    renderReceipt(data, 0, startY, "Office Copy");
    renderReceipt(data, 100, startY, "Parent's Copy");
    startY += receiptHeight;
  });

  window.open(doc.output("bloburl"), "_blank");
};

export default MiscellaneousFeeReceipt;
